export default {
  methods: {
    fieldSorter(fields) {
      return (a, b) => fields
        .map(o => {
          let newO = o
          let dir = 1
          if (o[0] === '-') {
            dir = -1
            newO = o.substring(1)
          }
          if (a[newO] > b[newO]) return dir
          if (a[newO] < b[newO]) return -dir
          return 0
        })
        .reduce((p, n) => (p || n), 0)
    },
  },
}
